export const TOKEN = "token";
export const USER = "user";
export const D_LIV69 = "d_liv69";